import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('my-approvals-contracts', storeModule.createStoreModule('my-approvals-contracts'))
